import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/admin/' // (4) 직원 조회

let swrData: any = getPersistData(KEY)

export function useEmployee(userId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + userId,
		async () => {
			const response = await API.get(KEY + userId, token + '', {})
			swrData = response.result?.result

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		employee: data,
		mutate: (value?: any) => {
			if (value !== undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}